import { Directive } from '@angular/core';

@Directive({
  selector: 'textarea[mwlTextInputElement]',
  host: {
    '[class.text-input-element]': 'true'
  }
})
export class TextInputElementDirective {}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/text-input-element.directive.ts